module.exports = __webpack_public_path__ + "static/img/epidemic-5.0ef3328.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-5.png
// module id = Nmyl
// module chunks = 1